import ClientPortalNoticeIntakeForm from './ClientPortalNoticeIntakeForm';

export default ClientPortalNoticeIntakeForm;
